import React from 'react'

import i18n from '../../locale/i18n'

const DataUnavailableIPO = () => {
  return <div className='data-unavailable-ipo'>
    <h4 className="data-unavailable-ipo__title">{i18n.translate("dataUnavailable")}</h4>
    <p className="data-unavailable-ipo__des">{i18n.translate("expectedData")}</p>
  </div>
}

export default DataUnavailableIPO